import { IconFn, IconSvg } from "../createIcon";

export const CreditCardIcon: IconFn = ({ color = "#F56B55", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 51, height: 41 }} {...props}>
    <g clipPath="url(#clip0_1613_12669)">
      <path
        d="M46.75 0C47.9187 0 48.9193 0.418186 49.7516 1.25456C50.5839 2.09093 51 3.09635 51 4.27083V36.7292C51 37.9036 50.5839 38.9091 49.7516 39.7454C48.9193 40.5818 47.9187 41 46.75 41H4.25C3.08125 41 2.08073 40.5818 1.24844 39.7454C0.416146 38.9091 0 37.9036 0 36.7292V4.27083C0 3.09635 0.416146 2.09093 1.24844 1.25456C2.08073 0.418186 3.08125 0 4.25 0H46.75ZM4.25 3.41667C4.01979 3.41667 3.82057 3.50119 3.65234 3.67025C3.48411 3.8393 3.4 4.0395 3.4 4.27083V10.25H47.6V4.27083C47.6 4.0395 47.5159 3.8393 47.3477 3.67025C47.1794 3.50119 46.9802 3.41667 46.75 3.41667H4.25ZM46.75 37.5833C46.9802 37.5833 47.1794 37.4988 47.3477 37.3298C47.5159 37.1607 47.6 36.9605 47.6 36.7292V20.5H3.4V36.7292C3.4 36.9605 3.48411 37.1607 3.65234 37.3298C3.82057 37.4988 4.01979 37.5833 4.25 37.5833H46.75ZM6.8 34.1667V30.75H13.6V34.1667H6.8ZM17 34.1667V30.75H27.2V34.1667H17Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_1613_12669">
        <rect width={51} height={41} fill="white" />
      </clipPath>
    </defs>
  </IconSvg>
);
